module.exports = __webpack_public_path__ + "static/media/main-home.20175377.png";